<template>
    <div class="py-8">
        <div class="text-center content-center">
            <h3 class="secondary--text mb-4">{{ fields.title }}</h3>
            <ctf-rich-text v-if="fields.description" class="mb-10" :document="fields.description" />
            <div style="max-width: 900px;width:100%;">
                <v-row no-gutters dense v-if="iconTiles.length > 0">
                    <v-col
                        cols="6"
                        sm="3"
                        class="my-3"
                        v-for="icon in iconTiles"
                        :key="icon.sys.id"
                    >
                        <icon-tile :fields="icon.fields" :btnId="icon.fields.button ? icon.fields.button.sys.id : null"/>
                    </v-col>
                </v-row>
            </div>
        </div>
    </div>
</template>

<script>
import { queryCTF, sortCTFEntries } from '@/plugins/contentful'
import IconTile from './icon-tile'

export default {
  name: 'IconTileGroup',
  components: {
    IconTile
  },
  props: {
    fields: {
      type: Object,
      required: true
    },
    sysId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      iconTiles: []
    }
  },
  async created () {
    const { items, includes } = await queryCTF(
            `&include=2&content_type=iconTileGroup&select.fields&sys.id=${this.sysId}`
    )
    if (items && includes) {
      const group = items[0]
      const entries = includes.Entry.filter((x) =>
        group.fields.iconTiles.find((t) => t.sys.id === x.sys.id)
      )
      const sortedEntries = sortCTFEntries(
        group.fields.iconTiles,
        entries
      )
      const sorted = sortedEntries.map((el) => {
        const img = includes.Asset.find(
          (a) => a.sys.id === el.fields.icon.sys.id
        )
        const ret = { ...el }
        ret.fields.iconUrl = img.fields.file.url
        ret.fields.iconAlt = img.fields.description
          ? img.fields.description
          : img.fields.title

        return ret
      })
      this.iconTiles = sorted
    }
  }
}
</script>
